import { Icon } from '@ezugi/primitives';

import ToggleDrawerIcon from '../../assets/icons/drawer-toggle.svg';

const DrawerToggler = () => (
  <Icon
    style={{ width: '100%', height: '20%' }}
    svg={ToggleDrawerIcon}
  />
);

export default DrawerToggler;
